module.exports = __webpack_public_path__ + "img/music-slash.ec48ce82.svg";